/**
 * Delivery prices in the visitor's currency.
 *
 * snippets/mlb-delivery-line.liquid prints delivery prices in GBP (the shop currency) as
 * [data-mlb-money="<pence>"]. When the visitor browses in another currency, convert with
 * the storefront's own rate and round up to a whole unit, prefixed "about", since checkout
 * applies its own rounding. The bag re-renders without running inline scripts, so new
 * nodes are picked up by an observer.
 */
const SELECTOR = '[data-mlb-money]:not([data-mlb-money-ready])';

function convertAll(scope = document) {
  const currency = window.Shopify?.currency;
  const active = currency?.active;
  const rate = Number(currency?.rate);
  for (const node of scope.querySelectorAll(SELECTOR)) {
    node.setAttribute('data-mlb-money-ready', '');
    if (!active || active === 'GBP' || !rate) continue;
    const amount = Math.ceil((Number(node.getAttribute('data-mlb-money')) / 100) * rate);
    if (!Number.isFinite(amount) || amount <= 0) continue;
    try {
      const formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: active,
        maximumFractionDigits: 0,
      }).format(amount);
      node.textContent = `about ${formatted}`;
    } catch {
      // Unknown currency code: keep the GBP price
    }
  }
}

convertAll();

new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element && (node.matches(SELECTOR) || node.querySelector(SELECTOR))) {
        convertAll(node.parentElement ?? document);
        return;
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });
